import { Routes } from '@angular/router';
import { CounterPaneComponent } from './counter-pane/counter-pane.component';

export const routes: Routes = [
    {path: "", component: CounterPaneComponent}
];
